import { GeneralChatConversationHeader } from "./GeneralChatConversationHeader";
import { ShipmentDetailChatConversationHeader } from "./ShipmentDetailChatConversationHeader";

interface Props {
  currentChannel: string;
  isShipmentDetailChat: boolean;
}

export function ChatConversationHeader(props: Props) {
  const { currentChannel, isShipmentDetailChat } = props;

  if (isShipmentDetailChat) {
    return (
      <ShipmentDetailChatConversationHeader currentChannel={currentChannel} />
    );
  }

  return <GeneralChatConversationHeader currentChannel={currentChannel} />;
}
